import SubscriptionService from '../services/subscription.service';
import { useSubscriptionStore } from '../store/subscription.store';

export const useLoadSubscription = () => {
  const subscriptionStore = useSubscriptionStore();

  const loadSubscription = async () => {
    try {
      subscriptionStore.setIsError(false);
      const newSubscriptionData = await SubscriptionService.load();
      subscriptionStore.setSubscription(newSubscriptionData);
      subscriptionStore.setIsLoaded(true);
    } catch (e) {
      subscriptionStore.setIsError(true);
    }
  };

  return { loadSubscription };
};
